import { HorizontalEndIcon } from "components/common/Icons/Alignment/HorizontalEndIcon";
import { HorizontalMiddleIcon } from "components/common/Icons/Alignment/HorizontalMiddleIcon";
import { HorizontalStartIcon } from "components/common/Icons/Alignment/HorizontalStartIcon";
import { VerticalMiddleIcon } from "components/common/Icons/Alignment/VerticalMiddleIcon";
import { VerticalStartIcon } from "components/common/Icons/Alignment/VerticalStartIcon";
import { TextBox } from "store/features/memeGenerator/types";
import { Chip } from "./Chip/Chip";
import { useAlignment } from "./useAlignment";

interface AlignmentProps {
    textBox: TextBox;
}

export const Alignment = ({ textBox }: AlignmentProps) => {
    const { handleClick } = useAlignment(textBox);
    return (
        <>
            <div className="flex items-center gap-4 justify-around bg-[rgba(242,243,245,0.96)] dark:bg-darkSurface-200 py-3 rounded-lg">
                <Chip
                    icon={<HorizontalStartIcon className="fill-black dark:fill-white" />}
                    isActive={textBox.alignment.horizontal === "start"}
                    onClick={() => handleClick({ horizontal: "start" })}
                />
                <Chip
                    icon={<HorizontalMiddleIcon className="fill-black dark:fill-white" />}
                    isActive={textBox.alignment.horizontal === "middle"}
                    onClick={() => handleClick({ horizontal: "middle" })}
                />
                <Chip
                    icon={<HorizontalEndIcon className="fill-black dark:fill-white" />}
                    isActive={textBox.alignment.horizontal === "end"}
                    onClick={() => handleClick({ horizontal: "end" })}
                />
            </div>
            <div className="flex items-center gap-4 justify-around bg-[rgba(242,243,245,0.96)] dark:bg-darkSurface-200 py-3 rounded-lg">
                <Chip
                    icon={<VerticalStartIcon className="fill-black dark:fill-white" />}
                    isActive={textBox.alignment.vertical === "start"}
                    onClick={() => handleClick({ vertical: "start" })}
                />
                <Chip
                    icon={<VerticalMiddleIcon className="fill-black dark:fill-white" />}
                    isActive={textBox.alignment.vertical === "middle"}
                    onClick={() => handleClick({ vertical: "middle" })}
                />
                <Chip
                    icon={<VerticalStartIcon className="fill-black rotate-180 dark:fill-white" />}
                    isActive={textBox.alignment.vertical === "end"}
                    onClick={() => handleClick({ vertical: "end" })}
                />
            </div>
        </>
    );
};
